<template>
    <span class="k-rate" :class="className">
        <span v-if="rateSign" class="k-rate__sign">{{rateSign}}</span><span class="k-rate__num">{{rateNum}}</span><span class="k-rate__per">%</span>
    </span>
</template>

<script>
    import {isString, isNumber} from '../../utils/base'
    export default {
        name: 'k-rate',
        props: ['value', 'fixed', 'sign', 'skin'],
        computed: {
            className() {
                const {skin, value, sign} = this
                if(isNumber(skin)) {
                    return skin < 0 ? 'down' : skin > 0 ? 'up' : 'flat'
                } else if(isString(skin) && skin) {
                    return skin
                } else if(skin === false) {
                    return '';
                }
                return value < 0 ? 'down' : value > 0 ? 'up' : 'flat';
            },
            rateSign() {
                return this.sign === true ? this.value < 0 ? '-' : '+' : ''
            },
            rateNum() {
                const fixed = +this.fixed
                let value = this.value * 100
                if(value < 0 && this.sign === true) {
                    value = -value
                }
                if(fixed < 0) {
                  value = +value.toFixed(-fixed)
                } else if(fixed >= 0) {
                  value = value.toFixed(fixed)
                } else {
                  value = value.toFixed(2)
                }
                return value
            }
        }
    };
</script>
